import React from 'react';
import Button from '../../Button';
import { MdClose } from 'react-icons/md';
import './FileUploadForm.scss';

const defaultExtension = ['.pdf', '.xls', '.xlsx', '.doc', '.docx', '.ppt', '.pptx'];

const FileUploadForm = (props) => {
  const { files, onChange, deleteFile, validExtension = defaultExtension } = props;

  return (
    <div className="form-file-upload">
      <div className="file-name">
        {files.length ? files[0].name : null}
        {files.length ? <MdClose onClick={deleteFile} /> : null}
      </div>

      <div className="form-file-update-wrap">
        <Button
          isRadius={true}
          className="form-file-upload-btn"
          color="primary"
          text={files.length ? '파일변경' : '파일첨부'}
        />

        <input type="file" className="file-input" accept={validExtension.join(',')} onChange={onChange} />
      </div>
    </div>
  );
};

export default FileUploadForm;
